import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.documentElement;
const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | 'system' | null;

if (!savedTheme) {
  localStorage.setItem('theme', 'system');
}

const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
const initialTheme = savedTheme === 'system'
  ? systemPrefersDark ? 'dark' : 'light'
  : savedTheme || 'light';

rootElement.classList.add(initialTheme);
rootElement.style.colorScheme = initialTheme;

document.body.style.backgroundColor = initialTheme === 'dark' ? '#0f172a' : '#ffffff';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: () => {
    const banner = document.createElement('div');
    banner.id = 'sw-update-banner';
    banner.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:99999;padding:12px 20px;background:#1e293b;color:#f8fafc;display:flex;align-items:center;justify-content:center;gap:12px;font-family:sans-serif;font-size:14px;box-shadow:0 -2px 10px rgba(0,0,0,.3)';
    banner.innerHTML = '<span>Uma nova versão está disponível.</span>';
    const btn = document.createElement('button');
    btn.textContent = 'Atualizar';
    btn.style.cssText = 'padding:6px 16px;border:none;border-radius:6px;background:#3b82f6;color:#fff;font-size:14px;cursor:pointer;font-weight:600';
    btn.onclick = () => window.location.reload();
    banner.appendChild(btn);
    document.body.appendChild(banner);
  },
});
